import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { OrganizationsService } from '@services/organizations.service';

@Injectable({
  providedIn: 'root',
})
export class ExistOrganizationGuard implements CanActivate {
  constructor(private organizationsService: OrganizationsService, private router: Router) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this.organizationsService.getOrganizationAsync().pipe(
      map((organization) => {
        return !!organization;
      }),
    );
  }
}
